import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '@core/services/storages.service';
import { SellsHistoryService } from './sells-history.service';
import { SellsHistory } from '@core/interfaces/catalogos.intefaces';
import { PromiseStatus } from '@shared/enums';

@Component({
  selector: 'app-so-sells-component',
  templateUrl: './so-sells-component.component.html',
  styleUrl: './so-sells-component.component.scss',
})
export class SoSellsComponentComponent implements OnInit {
  PromiseStatus = PromiseStatus;
  requestStatus = PromiseStatus.Pending;
  errorMessage: string = '';

  constructor(
    private storageService: StorageService,
    private sellsHistoryService: SellsHistoryService,
    private translateService: TranslateService
  ) {}
  @Input() responseData: any = {
    response: [],
  };

  ngOnInit(): void {
    const currentProspect = this.storageService.getLocalStorage(
      'currentProspectDirectory'
    );
    this.sellsHistoryService
    .getDemosHistory(currentProspect.idProspecto)
    .subscribe({
      next: (data: SellsHistory) => {
        this.responseData = data;
        this.requestStatus = PromiseStatus.Fulfilled;
      },
      error: ({ error }) => {
        this.errorMessage = error.message;
        this.requestStatus = PromiseStatus.Rejected;
      },
    });
  }
  translate(text: string) {
    return this.translateService.instant(text);
  }
}
